import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Card,
    CardContent,
    Typography,
    Stack,
    Chip,
    useTheme,
    useMediaQuery,
} from '@mui/material';

/**
 * Responsive table that converts to cards on mobile
 */
const ResponsiveTable = ({
    headers,
    rows,
    mobileCardRenderer, // Optional custom mobile card renderer
    desktopRowRenderer, // Optional custom desktop row renderer
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    // Default mobile card renderer
    const defaultMobileCardRenderer = (row, index) => (
        <Card key={index} sx={{ mb: 2 }}>
            <CardContent>
                <Stack spacing={1.5}>
                    {headers.map((header, i) => (
                        <Box key={i}>
                            <Typography variant="caption" color="text.secondary" display="block">
                                {header.label}
                            </Typography>
                            <Typography variant="body2" fontWeight="medium">
                                {row[header.key] || '-'}
                            </Typography>
                        </Box>
                    ))}
                </Stack>
            </CardContent>
        </Card>
    );

    // Default desktop row renderer
    const defaultDesktopRowRenderer = (row, index) => (
        <TableRow key={index} hover>
            {headers.map((header, i) => (
                <TableCell key={i}>
                    {row[header.key] || '-'}
                </TableCell>
            ))}
        </TableRow>
    );

    if (isMobile) {
        return (
            <Box>
                {rows.map((row, index) =>
                    mobileCardRenderer
                        ? mobileCardRenderer(row, index)
                        : defaultMobileCardRenderer(row, index)
                )}
            </Box>
        );
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow sx={{ bgcolor: 'primary.main' }}>
                        {headers.map((header, index) => (
                            <TableCell
                                key={index}
                                sx={{ color: 'white', fontWeight: 'bold' }}
                            >
                                {header.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) =>
                        desktopRowRenderer
                            ? desktopRowRenderer(row, index)
                            : defaultDesktopRowRenderer(row, index)
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ResponsiveTable;
